<template>
  <div class="integration">
    <div class="provider-field">
      <div>{{ $t('label.tags') }}</div>
      <AppSelect
        v-model="data.termsId"
        :loading="loading"
        :options="list"
        option-value="value"
        option-label="label"
        emit-value
        map-options
        multiple
      />
    </div>
    <AppToggle
      v-model="data.doi"
      class="text-right"
      :label="$t('label.enaldeDoi')"
      left-label
    />
  </div>
</template>

<script>
import AppSelect from 'common/components/AppSelect';
import AppToggle from 'common/components/AppToggle';
import handleError from 'common/helpers/handleError';
import { autoresponderMixin } from 'common/mixins';

export default {
  name: 'Quentn',
  components: { AppSelect, AppToggle },
  mixins: [autoresponderMixin],
  data() {
    return {
      loading: false,
      list: [],
      data: {
        type: ENUMS.AUTORESPONDER_TYPES.QUENTN,
        termsId: [],
        doi: false,
      },
    };
  },
  created() {
    this.fetch();
    this.data.doi = this.value?.data?.doi || true;
    this.data.termsId = this.value?.data?.termsId || [];
  },
  methods: {
    async fetch() {
      try {
        this.loading = true;
        this.list = [];
        const { data } = await this.$axios.get(`autoresponders/${this.value.autoresponderProviderId}/external`);
        Object.keys(data.data.termsId).forEach((value) => {
          this.list.push({
            value: +value,
            label: data.data.termsId[value],
          });
        });
      } catch (error) {
        handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
